import React, { useState, useEffect } from 'react';

import LabNinjasNormalSize from './normalSize'
import LabNinjasSmallSize from './smallSize'

export default function LabNinjas (){
      const [windowSize, setWindowSize] = useState([
        window.innerWidth,
      ]);

      useEffect(() => {
        const handleWindowResize = () => {
          setWindowSize([window.innerWidth]);
        };

        window.addEventListener('resize', handleWindowResize);

        return () => {
          window.removeEventListener('resize', handleWindowResize);
        };
      }, []);

     return windowSize[0] > 767 ? <LabNinjasNormalSize/> : <LabNinjasSmallSize/>;

}